import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MyProfile from '../pages/profile/MyProfile';
import {
  ApiPartnerCommissionReport,
  ApiPartnerDashboard,
  ApiPartnerIpWhiteListing,
  ApiPartnerLedger,
  ApiPartnerMyCommissionCharges,
  ApiPartnerTopUpHistory,
  ApiPartnerTopUpRequest,
  ApiPartnerWebhookSettings
} from '../pages/modules/api_partner';

const ApiPartnerRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard" element={<ApiPartnerDashboard />} />
      <Route path="/top-up-request" element={<ApiPartnerTopUpRequest />} />
      <Route path="/white-listing/webhook-url" element={<ApiPartnerWebhookSettings />} />
      <Route path="/white-listing/ip-white-listing" element={<ApiPartnerIpWhiteListing />} />
      <Route path="/ledger" element={<ApiPartnerLedger />} />
      <Route path="/commission-report" element={<ApiPartnerCommissionReport />} />
      <Route path="/my-commission" element={<ApiPartnerMyCommissionCharges />} />
      <Route path="/top-up-history" element={<ApiPartnerTopUpHistory />} />
      <Route path="/profile" element={<MyProfile />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

export default ApiPartnerRoutes;
